module.exports = __webpack_public_path__ + "img/banner-2.18147df1.png";